<div class="subcard-container">
  <div
    class="card cursor-pointer text-center p-2 subcard"
    [ngClass]="{
      enviado: status === 'Enviado',
      Ok: status === 'OK',
      enviar: status === 'Pendente',
      correcao: status === 'Correção'
    }"
    (click)="onCardClick()"
  >
    <div class="card-body">
      <h4
        ngbTooltip="{{ titulo }}"
        tooltipClass="tooltip"
        class="bold margin-title"
      >
        {{ titulo | SliceStringNamePipe }}
      </h4>
      <hr />
      <img
        [src]="imagemSrc"
        [alt]="titulo | SliceStringNamePipe"
        width="55px"
      />

      <p
        [ngClass]="{
          'text-success': status === 'Enviado' || status === 'OK',
          'text-secondary': status === 'Pendente' || status === 'Correção'
        }"
        class="bold mb-0 mt-2"
      >
        {{ status }}
        <i
          [ngClass]="{
            'fa-check-circle': status === 'Enviado' || status === 'OK',
            'fa-upload': status === 'Pendente' || status === 'Correção'
          }"
          class="fa fa-1x"
        ></i>
      </p>
    </div>
  </div>
</div>
